import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../../fulfillment-planner/labeled-row/messages';

import UserDateTimezoneFormat from '../../../components/user-date-timezone-format';
import LabeledRow from '../../../fulfillment-planner/labeled-row';

import style from './style.module.less';

const ShipDate = ({ shipDate = '', showMdash = false }) => (
  <LabeledRow className={style.row} label={<FormattedMessage {...messages.shipDate} />} labelClassName={style.label}>
    {showMdash ? (
      <span className={style.mdash}>&mdash;</span>
    ) : (
      <span className={style.info}>
        <UserDateTimezoneFormat dateTime={shipDate} />
      </span>
    )}
  </LabeledRow>
);

ShipDate.propTypes = {
  shipDate: PropTypes.string,
  showMdash: PropTypes.bool,
};

export default ShipDate;
